import { FunctionComponent, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';

import { useAuthContext } from '../contexts';
import { Loader } from '../shared_elements';
import { MnoProfile, User } from '../apis/core';
import { toastFlashMessage } from '../utils';
import { globalGetService } from '../utils/globalApiServices';
import { getRootPathRedirection } from '@/constants/paths';

const Home: FunctionComponent = () => {
  const { setUser, setProfile } = useAuthContext();
  const { oktaAuth, authState } = useOktaAuth();
  const history = useHistory();
  const location = useLocation();

  const logout = () => {
    localStorage.clear();
    oktaAuth.signOut();
  };

  const handleTokenExpired = () => {
    toastFlashMessage('Token expired! please try logging in again', 'error');
    logout();
  };

  const handleUnexpectedError = () => {
    toastFlashMessage('Please try logging in again', 'error');
    logout();
  };

  useEffect(() => {
    (async () => {
      if (!authState || authState.isLoading) {
        return;
      }
      if (!authState.isAuthenticated) {
        history.push('/login');
        return;
      }

      const userResponse = await globalGetService('user');
      if (userResponse.ok) {
        const user = userResponse.data as User;
        if (user) {
          setUser(user);
        }
      } else if (userResponse.status === 401) {
        handleTokenExpired();
        return;
      } else {
        handleUnexpectedError();
        return;
      }

      const profileResponse = await globalGetService('mno/profile');
      if (profileResponse.ok) {
        const profile = profileResponse.data as MnoProfile;
        if (profile) {
          setProfile(profile);
        }
      } else if (profileResponse.status === 401) {
        handleTokenExpired();
        return;
      } else {
        handleUnexpectedError();
        return;
      }

      const params = new URLSearchParams(location.search);
      const redirectUri = params.get('redirectUri');
      if (redirectUri) {
        window.location.href = decodeURIComponent(redirectUri);
      } else {
        history.push(getRootPathRedirection(profileResponse?.data?.market));
      }
    })();
  }, [authState?.isLoading, authState?.isAuthenticated]);

  return <Loader hocFlag />;
};

export default Home;
